var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { fragment, array } from 'ember-data-model-fragments/attributes';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import UUID from 'uuid-js';
import { CatalogObjectType } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { CatalogCustomAttributeDefinition } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/datatypes';
export let Type = /*#__PURE__*/function (Type) {
  Type["STRING"] = "STRING";
  Type["SELECTION"] = "SELECTION";
  Type["NUMBER"] = "NUMBER";
  Type["BOOLEAN"] = "BOOLEAN";
  return Type;
}({});
export let AppVisibility = /*#__PURE__*/function (AppVisibility) {
  AppVisibility["APP_VISIBILITY_HIDDEN"] = "APP_VISIBILITY_HIDDEN";
  AppVisibility["APP_VISIBILITY_READ_ONLY"] = "APP_VISIBILITY_READ_ONLY";
  AppVisibility["APP_VISIBILITY_READ_WRITE_VALUES"] = "APP_VISIBILITY_READ_WRITE_VALUES";
  return AppVisibility;
}({});
export let SellerVisibility = /*#__PURE__*/function (SellerVisibility) {
  SellerVisibility["SELLER_VISIBILITY_HIDDEN"] = "SELLER_VISIBILITY_HIDDEN";
  SellerVisibility["SELLER_VISIBILITY_READ_WRITE_VALUES"] = "SELLER_VISIBILITY_READ_WRITE_VALUES";
  return SellerVisibility;
}({});
let Data = (_dec = attr('string', {
  protoEnum: CatalogCustomAttributeDefinition.Type
}), _dec2 = attr('string'), _dec3 = attr('string', {
  defaultValue: () => UUID.create().toString()
}), _dec4 = attr('string'), _dec5 = fragment('connect/custom-attribute-definition/source-application'), _dec6 = array('string', {
  defaultValue() {
    return ['ITEM', 'ITEM_VARIATION'];
  },
  protoEnum: CatalogObjectType
}), _dec7 = array('string'), _dec8 = attr('string', {
  defaultValue: AppVisibility.APP_VISIBILITY_READ_WRITE_VALUES,
  protoEnum: CatalogCustomAttributeDefinition.AppVisibility
}), _dec9 = attr('string', {
  defaultValue: SellerVisibility.SELLER_VISIBILITY_READ_WRITE_VALUES,
  protoEnum: CatalogCustomAttributeDefinition.SellerVisibility
}), _dec10 = fragment('connect/custom-attribute-definition/string-config'), _dec11 = fragment('connect/custom-attribute-definition/selection-config'), _dec12 = fragment('connect/custom-attribute-definition/number-config'), _dec13 = attr('number'), _class = (_class2 = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "name", _descriptor2, this);
    _initializerDefineProperty(this, "key", _descriptor3, this);
    _initializerDefineProperty(this, "description", _descriptor4, this);
    _initializerDefineProperty(this, "sourceApplication", _descriptor5, this);
    // @ts-expect-error https://github.com/adopted-ember-addons/ember-data-model-fragments/issues/457
    _initializerDefineProperty(this, "allowedObjectTypes", _descriptor6, this);
    // @ts-expect-error https://github.com/adopted-ember-addons/ember-data-model-fragments/issues/457
    _initializerDefineProperty(this, "displayedObjectTypes", _descriptor7, this);
    _initializerDefineProperty(this, "appVisibility", _descriptor8, this);
    _initializerDefineProperty(this, "sellerVisibility", _descriptor9, this);
    _initializerDefineProperty(this, "stringConfig", _descriptor10, this);
    _initializerDefineProperty(this, "selectionConfig", _descriptor11, this);
    _initializerDefineProperty(this, "numberConfig", _descriptor12, this);
    _initializerDefineProperty(this, "customAttributeUsageCount", _descriptor13, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/custom-attribute-definition/data'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "key", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sourceApplication", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "allowedObjectTypes", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "displayedObjectTypes", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "appVisibility", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "sellerVisibility", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "stringConfig", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "selectionConfig", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "numberConfig", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "customAttributeUsageCount", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Data as default };